import React, { useEffect } from 'react';
import ModalContainer from '../../components/ModalContainer.jsx';
import { useLocation, useNavigate } from 'react-router-dom';
import DataList from '../../components/DataList.jsx';

const MaterialDetails = () => {
    const location = useLocation();
    const navigate = useNavigate();

    const materialRows = [
        {
            field: "group_name",
            text: "گروه"
        },
        {
            field: "afnor",
            text: "AFNOR"
        },
        {
            field: "aisi_sae",
            text: "AISI / SAE"
        },
        {
            field: "astm",
            text: "ASTM"
        },
        {
            field: "bts",
            text: "BTS"
        },
        {
            field: "sis",
            text: "SIS"
        },
        {
            field: "uni",
            text: "UNI"
        },
        {
            field: "uns",
            text: "UNS"
        },
        {
            field: null,
            text: "WNR",
            element: (rowData) => <span>{rowData.wnr ? Number(rowData.wnr).toFixed(4) : ""}</span>
        },
        {
            field: "din",
            text: "DIN"
        },
        {
            field: "en",
            text: "EN"
        },
        {
            field: "jis",
            text: "JIS"
        },
        {
            field: "english_group",
            text: "گروه انگلیسی"
        },
        {
            field: "persian_group",
            text: "گروه فارسی"
        },
        {
            field: "class_name",
            text: "کلاس انگلیسی"
        },
        {
            field: "persian_class",
            text: "کلاس فارسی"
        },
        {
            field: null,
            text: "هزینه (یک کیلو گرم)",
            element: (rowData) => <span>{rowData.cost.toLocaleString()} تومان</span>
        },
        {
            field: "density",
            text: "چگالی (kg/m3)"
        },
        {
            field: "machinability",
            text: "ماشین‌کاری (درصد)"
        },
        {
            field: "manufacturer_reference",
            text: "مرجع سازنده"
        },
        {
            field: null,
            text: "آدرس",
            element: (rowData) => {
                return rowData.link ? (
                    <a className="bg-primary px-3 py-1.5 
                    rounded-lg text-white"
                    href={`${rowData.link}`}
                        target="_blank"
                        rel="noreferrer">
                        مشاهده
                    </a>
                ) : (
                    <span className="text-red-500">ندارد</span>
                )
            }
        },
    ];

    useEffect(() => {
        if (!location.state) {
            return navigate(-1);
        }
    }, []);

    return (
        <ModalContainer
            alwaysOpen={true}
            fullscreen={false}
            title={`ماده اولیه "${location.state?.id}"`}
        >
            <DataList
                listData={location.state}
                listRowsTitles={materialRows}
            />
        </ModalContainer>
    );
}

export default MaterialDetails;
